import { render, staticRenderFns } from "./SemenCollectionn.vue?vue&type=template&id=1f1032b8&scoped=true&"
import script from "./SemenCollectionn.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionn.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionn.vue?vue&type=style&index=0&id=1f1032b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1032b8",
  null
  
)

export default component.exports